import React, { Component, Fragment } from "react";

import { ScrollingCarousel } from "@trendyol-js/react-carousel";

import "react-multi-carousel/lib/styles.css";

import ProductCard from "./card";
import ProductCreditCard from "./credit-card";
import ProductCardLoading from "./card-loading";
import Loader from "./../common/loader";

import { getStaticText, getPagePath } from "./../../helpers/system";

import ProductText from "./../../const/product.json";
import { FilterOtherProducts } from "./../../config/products";

export default class OtherProducts extends Component {
    _mounted = false;

    constructor(props) {
        super(props);

        this.state = {
            productsReady: false,
            products: [],
            lenderLogos: [],
            screenWidth: window.innerWidth,
        };
    }

    async componentDidMount() {
        this._mounted = true;

        await this.getProductsList();

        this.initializeEvents();
    }

    componentWillUnmount() {
        this._mounted = false;

        this.uninitializeEvents();
    }

    initializeEvents() {
        window.addEventListener("resize", (e) => this.updateWindowDimensions(e));
    }

    uninitializeEvents() {
        window.removeEventListener("resize", (e) => this.updateWindowDimensions(e));
    }

    updateWindowDimensions() {
        if (this._mounted) {
            this.setState({ screenWidth: window.innerWidth });
        }
    }

    async getProductsList() {
        const { getProducts = false, viewingTopOrg = false, viewingProductCode = false } = this.props;

        if (getProducts) {
            if (this._mounted) {
                await this.setState({
                    productsLoading: true,
                    productsReady: false,
                });
            }

            let products = await getProducts();

            if (FilterOtherProducts.includes(viewingTopOrg)) {
                products = products.filter((product) => {
                    const { topOrg, product: productCode } = product;
                    const { code } = productCode;

                    if (topOrg === viewingTopOrg && code !== viewingProductCode) {
                        return product;
                    }

                    return false;
                });
            }

            if (this._mounted) {
                await this.setState({
                    products,
                    productsReady: true,
                    productsLoading: false,
                });
            }
        }
    }

    renderCards() {
        const { products } = this.state;

        let renderedCards = [];

        products.forEach((product) => {
            const { id, urlPath, config = {} } = product;
            const isCreditCard = config.loan_type === "credit_card";
            renderedCards.push(
                <div key={id}>
                    {isCreditCard ? (
                        <ProductCreditCard
                            product={product}
                            link={getPagePath("Product", { "product_id": urlPath || id })}
                            showRange={true}
                            other={true}
                        />
                    ) : (
                        <ProductCard
                            product={product}
                            link={getPagePath("Product", { "product_id": urlPath || id })}
                            showRange={true}
                            other={true}
                        />
                    )}
                </div>,
            );
        });

        return renderedCards;
    }

    renderLoading() {
        return (
            <Fragment>
                <Loader height="30" width="40%" />
                <div className="row mt-32">
                    <div className="col-12 col-md-4 col-lg-3">
                        <ProductCardLoading />
                    </div>
                    <div className="col-12 d-none d-md-block col-md-4 col-lg-3">
                        <ProductCardLoading />
                    </div>
                    <div className="col-12 d-none d-md-block col-md-4 col-lg-3">
                        <ProductCardLoading />
                    </div>
                    <div className="col-12 d-none d-lg-block col-md-4 col-lg-3">
                        <ProductCardLoading />
                    </div>
                </div>
            </Fragment>
        );
    }

    renderContent() {
        const { viewingProductOrg = false } = this.props;
        const { products = [] } = this.state;

        let renderedContent = "";

        if (products.length > 0) {
            renderedContent = (
                <Fragment>
                    <h2 className="other-products-header">
                        {getStaticText(ProductText, ["otherProductHeader", viewingProductOrg])}
                    </h2>
                    <div className="products">
                        <ScrollingCarousel className="product-carousel">{this.renderCards()}</ScrollingCarousel>
                    </div>
                </Fragment>
            );
        }

        return renderedContent;
    }

    render() {
        const { productsReady, productsLoading } = this.state;

        let renderedContent = "";
        if (productsLoading) {
            renderedContent = this.renderLoading();
        }

        if (productsReady) {
            renderedContent = this.renderContent();
        }

        return (
            <section id="product-details-other-products">
                <div className="container-xl py-24">{renderedContent}</div>
            </section>
        );
    }
}
